import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  getProceedToAnalysis,
  proceedAnalyticsStatus,
} from "../../network/cipAPI";

import DupontDialog from "../../components/DupontDialog";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";
import "./index.scss";
import { API_URLS } from "../../network/appUrls";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";

const basePath = API_URLS.basePath;

const NormalizationCheck = ({
  isNormalizationPopUpOpen,
  setIsNormalizationPopUpOpen,
  isDataCleaningDialogOpen,
  setIsDataCleaningDialogOpen,
  setIdentifiedCECS,
  setCecWarningMessage,
  plantId,
  fileId,
  view,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let intervalId = 0;
  const [showOverLayLoader, setShowOverLayLoader] = useState(false);
  const [message, setMessage] = useState(
    view === 3
      ? t("analyseData.alreadyNormalizationDescription")
      : t("analyseData.alreadyNormalizationDescription")
  );

  const checkStatus = async () => {
    try {
      setShowOverLayLoader(true);
      const predictionStatus = await proceedAnalyticsStatus();
      const status = predictionStatus?.data?.status?.toLowerCase();
      const description = predictionStatus?.data?.description;
      if (status === "completed") {
        setIdentifiedCECS(true);
        clearInterval(intervalId);
        setShowOverLayLoader(false);
        // const path = `${basePath}home?plantId=${plantId}`;
        // navigate(path);
        setCecWarningMessage("");
        setIsNormalizationPopUpOpen(false);
        setIsDataCleaningDialogOpen(false);
      } else if (status === "completed_with_warnings") {
        clearInterval(intervalId);
        setShowOverLayLoader(false);
        // Set warning message FIRST, before opening the dialog
        if (setCecWarningMessage) {
          setCecWarningMessage(description || "The analysis completed with warnings.");
        }
        // Then open the IdentifyCIP dialog
        setIdentifiedCECS(true);
        setIsNormalizationPopUpOpen(false);
        setIsDataCleaningDialogOpen(false);
      } else if (
        status === "data_cleaning_in_progress" ||
        status === "cleaning_id_in_progress" ||
        status === "post_processing_in_progress"
      ) {
        setIsDataCleaningDialogOpen(true);
        setIsNormalizationPopUpOpen(false);
        setMessage(description);
      } else if (status === "error") {
        setIsNormalizationPopUpOpen(false);
        setIsDataCleaningDialogOpen(false);
        clearInterval(intervalId);
        createNotification(ERROR_NOTIFICATION, description, "");
      } else {
        setIsNormalizationPopUpOpen(true);
        setMessage(description);
        setShowOverLayLoader(true);
      }
    } catch (err) {
      console.log("Error is: ", err);
      clearInterval(intervalId);
      setIsNormalizationPopUpOpen(false);
      setIsDataCleaningDialogOpen(false);
    }
  };

  const onClose = async (action) => {
    try {
      if (action === "CONFIRM") {
        setShowOverLayLoader(true);
        const response = await getProceedToAnalysis(fileId);
        if (response && response.status === 200) {
          intervalId = setInterval(checkStatus, 5000);
        } else {
          createNotification(
            ERROR_NOTIFICATION,
            response.data.detail.error,
            ""
          );
        }
      } else if (action === "CANCEL") {
        setIsNormalizationPopUpOpen(false);
      }
    } catch (error) {
      createNotification(
        ERROR_NOTIFICATION,
        t("notificationStrings.somethingWrong"),
        ""
      );
      setShowOverLayLoader(false);
      console.log("onClose", error);
    }
  };

  const handleDataCleaningClose = () => {
    setIsDataCleaningDialogOpen(false);
  };

  return (
    <>
      {isNormalizationPopUpOpen && (
        <DupontDialog
          open={isNormalizationPopUpOpen}
          onClose={onClose}
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <span style={{ marginRight: 12 }}>
                {view === 3
                  ? t("analyseData.processCheck")
                  : t("analyseData.processCheck")}
              </span>
              {view !== 3 && (
                <PopoverText
                  descriptor={<img src={InfoIconGreen} alt="icon" />}
                  descriptionText={t("analyseData.infonormalisedcheck")}
                />
              )}
            </div>
          }
          confirmBtnText={t("ValueStrings.confirm")}
          maxwidth="xl"
          minWidth={775}
          isOverlayLoader={showOverLayLoader}
          customHeight={"260px"}
          cancelBtnText={t("ValueStrings.cancel")}
        >
          <div className="lightGrayBorder padding10 descriptionText font-14 ">
            <div className=" flex-between position-relative ">
              <div className="margin-top-10 ">{message}</div>
            </div>
          </div>
        </DupontDialog>
      )}

      {isDataCleaningDialogOpen && (
        <DupontDialog
          open={isDataCleaningDialogOpen}
          onClose={handleDataCleaningClose}
          title={t("analyseData.analysisProgress")}
          maxwidth={800}
          minWidth={775}
          isOverlayLoader={showOverLayLoader}
          customHeight={"240px"}
        >
          <div className="lightGrayBorder padding10 descriptionText font-14 ">
            <div className=" flex-between position-relative ">
              <div className="margin-top-10 ">{message}</div>
            </div>
          </div>
        </DupontDialog>
      )}
    </>
  );
};

export default NormalizationCheck;
